// assets/custom-cart-block.js

console.log('[DEBUG] custom-cart-block.js: Script execution STARTING.');

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
}

if (typeof window.CUSTOM_CART_GLOBALS === 'undefined') {
  window.CUSTOM_CART_GLOBALS = {};
}
if (typeof window.CUSTOM_CART_GLOBALS.ON_CHANGE_DEBOUNCE_TIMER === 'undefined') {
  window.CUSTOM_CART_GLOBALS.ON_CHANGE_DEBOUNCE_TIMER = 450;
}
if (typeof window.CUSTOM_CART_GLOBALS.PUB_SUB_EVENTS === 'undefined') {
  window.CUSTOM_CART_GLOBALS.PUB_SUB_EVENTS = { cartUpdate: 'cart:update' };
}
if (typeof window.CUSTOM_CART_GLOBALS.subscribers === 'undefined') {
  window.CUSTOM_CART_GLOBALS.subscribers = {};
}

function customSubscribe(event, callback) {
  if (!window.CUSTOM_CART_GLOBALS.subscribers[event]) {
    window.CUSTOM_CART_GLOBALS.subscribers[event] = [];
  }
  window.CUSTOM_CART_GLOBALS.subscribers[event].push(callback);
  return () => {
    window.CUSTOM_CART_GLOBALS.subscribers[event] = window.CUSTOM_CART_GLOBALS.subscribers[event].filter(cb => cb !== callback);
  };
}

function customPublish(event, data) {
  if (!window.CUSTOM_CART_GLOBALS.subscribers[event] || window.CUSTOM_CART_GLOBALS.subscribers[event].length === 0) {
    return;
  }
  window.CUSTOM_CART_GLOBALS.subscribers[event].forEach(callback => callback(data));
}

if (typeof window.Shopify === 'undefined') { window.Shopify = { routes: { root: '/' } }; }
else if (typeof window.Shopify.routes === 'undefined') { window.Shopify.routes = { root: '/' }; }
else if (typeof window.Shopify.routes.root === 'undefined') { window.Shopify.routes.root = '/'; }

const shopifyRoot = window.Shopify.routes.root;
const routes = {
  cart_url: `${shopifyRoot}cart`,
  cart_update_url: `${shopifyRoot}cart/update.js`,
  cart_change_url: `${shopifyRoot}cart/change.js`,
};

if (!window.CUSTOM_CART_GLOBALS.cartStrings) {
  window.CUSTOM_CART_GLOBALS.cartStrings = { error: 'There was an error updating your cart.', quantityError: 'Not enough items in stock. Max available: [quantity].' };
}
if (!window.CUSTOM_CART_GLOBALS.quickOrderListStrings) {
  window.CUSTOM_CART_GLOBALS.quickOrderListStrings = { min_error: 'Minimum quantity is [min].', max_error: 'Maximum quantity is [max].', step_error: 'Quantity must be a multiple of [step].' };
}

function fetchConfig() {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };
}

class CustomCartPerformance {
  static measure(name, task) { if (typeof task === 'function') { try { task(); } catch (e) { console.error(`[PERF] Error in task "${name}":`, e); } } }
  static measureFromEvent(name, event) { /* Placeholder */ }
}

class CustomCartBlockRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('custom-cart-block-items');
      if (cartItems) {
        console.log('[DEBUG] RemoveButton: Calling updateQuantity with 0.');
        cartItems.updateQuantity(this.dataset.index, 0, event);
      } else { console.error('Parent CustomCartBlockItems not found for remove button.'); }
    });
  }
}
customElements.define('custom-cart-block-remove-button', CustomCartBlockRemoveButton);

class CustomCartBlockItems extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    if (!this.sectionId) {
        const closestSectionWrapper = this.closest('[data-section-id]');
        if (closestSectionWrapper) { this.sectionId = closestSectionWrapper.dataset.sectionId; }
    }
    if (!this.sectionId) { console.error('[DEBUG] CustomCartBlockItems: CRITICAL - sectionId missing.'); }

    this.lineItemStatusElement = this.querySelector(`#shopping-cart-line-item-status-${this.sectionId}`) || document.getElementById(`shopping-cart-line-item-status-${this.sectionId}`) || document.getElementById('CartDrawer-LineItemStatus');
    this.debouncedOnChange = debounce((event) => { this.onChange(event); }, window.CUSTOM_CART_GLOBALS.ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', (event) => {
        const target = event.target;
        const quantityButton = target.closest('.quantity__button');
        if (quantityButton && quantityButton.tagName === 'BUTTON') {
            console.log(`[DEBUG] CustomCartBlockItems Click: Button "${quantityButton.name}" clicked. Letting external handler modify value and dispatch 'change'.`);
            // No event.preventDefault() or event.stopPropagation()
            // No quantity calculation or value setting here.
        }
    });
    console.log('[DEBUG] CustomCartBlockItems: Delegated "click" listener for buttons set up (now passive).');
  }

  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = customSubscribe(window.CUSTOM_CART_GLOBALS.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === `custom-cart-block-items-${this.sectionId}`) { return; }
    });
    this.reapplyDynamicListeners();
  }
  disconnectedCallback() { if (this.cartUpdateUnsubscriber) { this.cartUpdateUnsubscriber(); } }

  reapplyDynamicListeners() {
    this.querySelectorAll('quantity-input .quantity__input').forEach(inputEl => {
        if (inputEl.getAttribute('min') !== '0') {
            // console.log(`[DEBUG] Setting min attribute of input ${inputEl.id} to 0.`);
            inputEl.setAttribute('min', '0');
        }
    });
  }

  resetQuantityInput(lineIndex) {
    const input = this.querySelector(`#Quantity-${lineIndex}-${this.sectionId}`);
    if (input) { input.value = input.getAttribute('value'); }
  }

  setValidity(event, lineIndex, message) {
    event.target.setCustomValidity(message); event.target.reportValidity();
    this.resetQuantityInput(lineIndex); event.target.select();
  }

  validateQuantity(event) { // This is triggered by the 'change' event
    const inputElement = event.target;
    console.log(`[DEBUG] ValidateQuantity (from change event): Input value is "${inputElement.value}" for ${inputElement.id}`);
    const inputValue = parseInt(inputElement.value);
    const lineIndex = inputElement.dataset.index;
    let message = '';

    if (isNaN(inputValue)) {
        message = "Please enter a valid number.";
        this.setValidity(event, lineIndex, message);
        return;
    }

    if (inputValue === 0) {
        console.log(`[DEBUG] ValidateQuantity: Value is 0. Proceeding to update for removal.`);
        inputElement.setCustomValidity('');
        this.updateQuantity( lineIndex, 0, event, inputElement.name, inputElement.dataset.quantityVariantId );
        return;
    }

    const minProductRuleVal = parseInt(inputElement.dataset.min) || 1;
    const maxVal = inputElement.hasAttribute('max') ? parseInt(inputElement.max) : Infinity;
    const stepVal = parseInt(inputElement.step) || 1;
    const quickOrderStrings = window.CUSTOM_CART_GLOBALS.quickOrderListStrings || {min_error: 'Min err', max_error: 'Max err', step_error: 'Step err'};

    if (inputValue < minProductRuleVal) { message = quickOrderStrings.min_error.replace('[min]', minProductRuleVal); }
    else if (inputValue > maxVal && maxVal !== Infinity) { message = quickOrderStrings.max_error.replace('[max]', maxVal); }
    else if (inputValue % stepVal !== 0) { message = quickOrderStrings.step_error.replace('[step]', stepVal); }

    if (message) {
        console.log(`[DEBUG] ValidateQuantity: Validation FAILED for >0. Message: ${message}`);
        this.setValidity(event, lineIndex, message);
    } else {
      console.log(`[DEBUG] ValidateQuantity: Validation PASSED for >0. Calling updateQuantity.`);
      inputElement.setCustomValidity('');
      this.updateQuantity( lineIndex, inputValue, event, inputElement.name, inputElement.dataset.quantityVariantId );
    }
  }

  onChange(event) { // This is the entry point after external handler (or user direct input)
    console.log(`[DEBUG] OnChange Handler: Triggered for target:`, event.target, `Value: ${event.target.value}`);
    if (event.target.classList.contains('quantity__input') && this.contains(event.target)) {
        this.validateQuantity(event);
    }
  }

  getSectionsToRender() {
    const sectionsToRender = []; if (!this.sectionId) { return []; }
    const itemsId = `cart-items-container-${this.sectionId}`; if (this.querySelector(`#${itemsId}`)) { sectionsToRender.push({ id: itemsId, section: this.sectionId, selector: `#${itemsId}`}); }
    const footerId = `cart-footer-contents-${this.sectionId}`; if (this.querySelector(`#${footerId}`)) { sectionsToRender.push({ id: footerId, section: this.sectionId, selector: `#${footerId}`}); }
    if (document.getElementById('cart-icon-bubble')) { sectionsToRender.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'}); }
    const liveRegionId = `cart-live-region-text-${this.sectionId}`; if (this.querySelector(`#${liveRegionId}`)) { sectionsToRender.push({ id: liveRegionId, section: this.sectionId, selector: `#${liveRegionId}`}); }
    return sectionsToRender.filter(s => s.section && document.getElementById(s.id));
  }

  updateQuantity(line, quantity, event, name, variantId) {
    console.log(`[DEBUG] UpdateQuantity: Line: ${line}, Quantity: ${quantity}`);
    if (!this.sectionId) { this.disableLoading(line); return; }
    this.enableLoading(line); const sectionsToFetch = this.getSectionsToRender();
    const bodyPayload = JSON.stringify({ line, quantity, sections: sectionsToFetch.map(s => s.section).filter((v,i,a) => a.indexOf(v)===i), sections_url: window.location.pathname });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: bodyPayload })
      .then(response => { if (!response.ok) { return response.json().then(err => { throw err; }).catch(() => response.text().then(txt => { throw new Error(txt); })); } return response.text(); })
      .then(stateText => {
        let parsedState;
        try { parsedState = JSON.parse(stateText); }
        catch (e) { this.updateLiveRegions(line, window.CUSTOM_CART_GLOBALS.cartStrings.error); this.resetQuantityInput(line); return; }
        console.log(`[DEBUG] UpdateQuantity: Parsed state from Shopify:`, parsedState);

        CustomCartPerformance.measure("paint-updated-sections", () => {
          if (parsedState.errors) {
            const errorMsg = typeof parsedState.errors === 'string' ? parsedState.errors : JSON.stringify(parsedState.errors);
            console.error("Shopify API errors:", errorMsg); this.resetQuantityInput(line); this.updateLiveRegions(line, errorMsg); return;
          }
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const itemsWrapper = this.querySelector(`#main-cart-items-${this.sectionId}`); if(itemsWrapper) itemsWrapper.classList.toggle('hidden', parsedState.item_count === 0);
          const footerWrapper = this.querySelector(`#main-cart-footer-${this.sectionId}`); if (footerWrapper) footerWrapper.classList.toggle('hidden', parsedState.item_count === 0);

          sectionsToFetch.forEach(sectionConfig => {
            const targetEl = document.getElementById(sectionConfig.id);
            if (targetEl && parsedState.sections && parsedState.sections[sectionConfig.section]) {
              const newHTML = this.getSectionInnerHTML(parsedState.sections[sectionConfig.section], sectionConfig.selector);
              if (newHTML !== null) { targetEl.innerHTML = newHTML; }
            }
          });
          this.reapplyDynamicListeners();

          const qtyInputEl = this.querySelector(`#Quantity-${line}-${this.sectionId}`);
          let UIMessage = '';

          if (quantity === 0) {
             const itemRowEl = this.querySelector(`#CartItem-${line}-${this.sectionId}`); // The row for the item
             if (!itemRowEl) { // If the row itself is gone after re-render
                console.log(`[DEBUG] Item line ${line} visually removed (row not found after render).`);
             } else if (qtyInputEl){ // Row still there, Shopify might have adjusted qty (e.g. back to min if 0 not allowed)
                 const updatedItemData = parsedState.items.find(item => item.key === itemRowEl.dataset.key);
                 if (updatedItemData && updatedItemData.quantity > 0) { // Shopify did not remove it
                    console.warn(`[DEBUG] Sent qty 0 for line ${line}, but item still in cart with Shopify qty: ${updatedItemData.quantity}`);
                    qtyInputEl.value = updatedItemData.quantity;
                    UIMessage = "Item quantity adjusted by store.";
                 } else if (!updatedItemData) { // Item not in response, but row somehow still there (shouldn't happen if render is correct)
                    console.log(`[DEBUG] Item line ${line} seems removed (not in parsedState.items), but row still exists.`);
                 }
             }
          } else if (qtyInputEl) { // For non-zero updates
            const itemRowEl = this.querySelector(`#CartItem-${line}-${this.sectionId}`);
            const updatedItemData = itemRowEl ? parsedState.items.find(item => item.key === itemRowEl.dataset.key) : null;
            if(updatedItemData && updatedItemData.quantity !== parseInt(qtyInputEl.value)) { // If Shopify returned a different quantity
                qtyInputEl.value = updatedItemData.quantity;
                UIMessage = (window.CUSTOM_CART_GLOBALS.cartStrings.quantityError || '').replace('[quantity]', updatedItemData.quantity);
            }
          }
          this.updateLiveRegions(line, UIMessage);
        });
        customPublish(window.CUSTOM_CART_GLOBALS.PUB_SUB_EVENTS.cartUpdate, { source: `custom-cart-block-items-${this.sectionId}`, cartData: parsedState, variantId: variantId });
      })
      .catch(error => {
          let errorMessage = "An unknown error occurred.";
          if (error instanceof Error) { errorMessage = error.message; }
          else if (typeof error === 'object' && error !== null && error.description) { errorMessage = error.description; }
          else if (typeof error === 'string') { errorMessage = error; }
          console.error(`[DEBUG] Fetch .catch():`, errorMessage, error);
          this.updateLiveRegions(line, errorMessage);
          this.resetQuantityInput(line);
      })
      .finally(() => { this.disableLoading(line); });
  }

  updateLiveRegions(lineIndex, message) {
    const errElContainer = this.querySelector(`#Line-item-error-${lineIndex}-${this.sectionId}`);
    if (errElContainer) {
        const errTextEl = errElContainer.querySelector('.cart-item__error-text');
        if (errTextEl) errTextEl.textContent = message;
        errElContainer.style.display = message ? 'block' : 'none';
    }
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatusLiveRegion = this.querySelector(`#cart-live-region-text-${this.sectionId}`);
    if (cartStatusLiveRegion) {
        if(message) cartStatusLiveRegion.textContent = message;
        cartStatusLiveRegion.setAttribute('aria-hidden', false);
        setTimeout(() => { cartStatusLiveRegion.setAttribute('aria-hidden', true); if(message) cartStatusLiveRegion.textContent = ''; }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html'); const el = parsed.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  enableLoading(lineIndex) {
    const itemsCont = this.querySelector(`#main-cart-items-${this.sectionId}`); if (itemsCont) itemsCont.classList.add('cart__items--disabled');
    const spinner = this.querySelector(`#CartItem-${lineIndex}-${this.sectionId} .loading__spinner`); if(spinner) spinner.classList.remove('hidden');
    if(document.activeElement && typeof document.activeElement.blur === 'function') { document.activeElement.blur(); }
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(lineIndex) {
    const itemsCont = this.querySelector(`#main-cart-items-${this.sectionId}`); if (itemsCont) itemsCont.classList.remove('cart__items--disabled');
    const spinner = this.querySelector(`#CartItem-${lineIndex}-${this.sectionId} .loading__spinner`); if(spinner) spinner.classList.add('hidden');
  }
}
customElements.define('custom-cart-block-items', CustomCartBlockItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
        this.debouncedUpdateNote = debounce(async (event) => {
          const noteValue = event.target.value;
          const cartBlockRoot = this.closest('custom-cart-block-items');
          const currentSectionId = cartBlockRoot ? cartBlockRoot.dataset.sectionId : null;
          if (!cartBlockRoot || !currentSectionId) { return; }
          const formId = `cart-form-${currentSectionId}`;
          if (!this.closest(`form#${formId}`)) { return; }
          const body = JSON.stringify({ note: noteValue });
          try {
            const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
            if (!response.ok) { console.error("Error updating cart note:", await response.text()); }
            else { CustomCartPerformance.measureFromEvent(`note-update:user-action-${currentSectionId}`, event); }
          } catch (e) { console.error("Exception updating cart note:", e); }
        }, window.CUSTOM_CART_GLOBALS.ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener('input', this.debouncedUpdateNote.bind(this));
      }
    });
}
console.log('[DEBUG] custom-cart-block.js: Script execution FINISHED.');